import React from "react"
import tw from "twin.macro"

import { withMain } from "./withMain"

const StyledMain = tw.main`pt-0 md:pt-0 bg-light`
// const StyledMain = tw.main`pt-0 sm:pt-1-2 md:pt-3-2`

export const Main = withMain(({ children }): JSX.Element => <StyledMain>{children}</StyledMain>)
